export default {
  methods: {
    isLargeScreen: function () {
      return window.innerWidth > 1920
    },
    isMaxWidth1920: function () {
      return window.innerWidth <= 1920
    },
    isMaxWidth1366: function () {
      return window.innerWidth <= 1366
    },
    isMaxWidth1280: function () {
      return window.innerWidth <= 1280
    },
    isDesktop: function () {
      return window.innerWidth > 1024
    },
    isTablet: function () {
      return window.innerWidth >= 768 && window.innerWidth <= 1024
    },
    isMaxWidth1024: function () {
      return window.innerWidth <= 1024
    },
    isMaxWidthIpadLandscape: function () {
      return window.innerWidth === 1024
    },
    isMaxWidth768: function () {
      return window.innerWidth <= 768
    },
    isIpadPortrait: function () {
      return window.innerWidth === 768
    },
    isMobile: function () {
      return window.innerWidth < 768
    },
    isMaxWidth480: function () {
      return window.innerWidth <= 480
    },
    isMaxWidth360: function () {
      return window.innerWidth <= 360
    },
    isIphone5: function () {
      return window.innerWidth <= 320
    },
    isIphone5Landscape: function () {
      return window.innerWidth <= 568
    },
    isIphone678: function () {
      return window.innerWidth <= 375
    },
    isIphone678Landscape: function () {
      return window.innerWidth <= 667
    },
    isIphone678Plus: function () {
      return window.innerWidth <= 414
    },
    isIphone678PlusLandscape: function () {
      return window.innerWidth <= 736
    },
    isIphoneX: function () {
      return window.innerWidth <= 375
    },
    isIphoneXLandscape: function () {
      return window.innerWidth <= 812
    }
  }
}
